import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { type RootState } from '../reducers';
import { WAITLIST_FTUE_POPUP_TOGGLE } from '../types/waitlist';

export function toggleWaitListFTUEPopup() {
    return (dispatch: ThunkDispatch<RootState, void, Action>) => {
        dispatch({
            type: WAITLIST_FTUE_POPUP_TOGGLE,
        });
    };
}
